// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'tablet';

export const Component = () => (
  <path d='M19.183 2H5.485c-.431 0-.766.144-1.054.431A1.408 1.408 0 0 0 4 3.485v17.673c0 .431.144.766.431 1.005.288.288.623.432 1.054.432h13.698c.431 0 .766-.144 1.054-.432.287-.239.431-.575.431-1.005V3.485c0-.431-.144-.766-.431-1.054A1.408 1.408 0 0 0 19.183 2ZM4.959 3.006h14.75v14.607l-14.75.144V3.007Zm14.75 18.678H4.96v-2.97h14.75v2.97Zm-6.417-1.964h-1.915a3.222 3.222 0 0 0 0 .958h1.915a3.2 3.2 0 0 0 0-.958Z' />
);

export const viewBox = '0 0 25 25';
